import React from 'react';

const RolesTab = ({
  roles,
  loading,
  openCreateRoleModal,
  openEditRoleModal,
  handleDeleteRole
}) => {
  return (
    <div className="roles-view">
      <div className="view-header">
        <button className="btn btn-primary" onClick={openCreateRoleModal}>
          + Add Role
        </button>
      </div>
      <div className="items-grid">
        {roles.map(role => (
          <div key={role.role_id} className="item-card" style={{ borderLeft: `4px solid ${role.color}` }}>
            <div className="item-header">
              <h3>{role.name}</h3>
            </div>
            <div className="item-details">
              {role.description && <p>{role.description}</p>}
              {role.tph && <p><strong>Target per hour:</strong> {role.tph}</p>}
            </div>
            <div className="item-actions">
              <button className="btn btn-sm" onClick={() => openEditRoleModal(role)}>Edit</button>
              <button className="btn btn-sm btn-danger" onClick={() => handleDeleteRole(role)} disabled={loading}>Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RolesTab;
